module.exports = __webpack_public_path__ + "img/img6.c341ba04.png";